// @flow

import React, { Component, type Node } from "react";
import { noop, get } from "lodash";
import type { UnaryFn } from "@tvg/types/Functional";
import ScrollArea from "@fdr/static-ui/ScrollArea";

type Props = {
  children: Node[],
  onHandleTransition: UnaryFn<number, void>,
  setSwipeController?: UnaryFn<Node, void>,
  activeIndex: ?number,
  isLoading: boolean,
  background: string,
  delayUpdate: boolean,
  changeShouldUpdate: UnaryFn<boolean, void>,
  isFreeScroll: boolean,
  isSlidesCentered: boolean
};

export default class MagnetScrollArea extends Component<Props> {
  static defaultProps = {
    onHandleTransition: noop,
    setSwipeController: noop,
    children: [],
    activeIndex: 0,
    isLoading: false,
    background: "",
    delayUpdate: false,
    changeShouldUpdate: noop,
    isFreeScroll: false,
    isSlidesCentered: false
  };

  swiper: any;

  setSwiper = (swiper: any) => {
    this.swiper = swiper;

    // This verification aims to prevent a bug where a stack of event listeners
    // was being created and causing
    // multiple triggers
    if (!get(this.swiper, "eventsListeners.transitionEnd")) {
      /* istanbul ignore next line */
      this.swiper.on("transitionEnd", () => {
        this.props.onHandleTransition(swiper.activeIndex);
      });
    }

    this.swiper.autoHeight = !this.props.isFreeScroll;

    this.swiper.freeMode = this.props.isFreeScroll;
    this.swiper.freeModeMomentumBounce = false;
    this.swiper.slideToClickedSlide = true;

    let resizeId;

    if (this.props.delayUpdate) {
      clearTimeout(resizeId);
      resizeId = setTimeout(() => {
        this.swiper.updateAutoHeight(200, false);
        this.props.changeShouldUpdate(false);
      }, 600);
    }

    if (this.props.activeIndex !== null && this.props.isFreeScroll) {
      this.props.onHandleTransition(0);
    }

    if (!this.swiper.animating && this.props.activeIndex !== null) {
      this.swiper.slideTo(
        this.props.activeIndex,
        this.props.isFreeScroll ? 350 : 0
      );
    }
  };

  componentDidUpdate(prevProps: Props) {
    // We scroll the component when the props active index changes
    if (
      this.swiper &&
      this.props.activeIndex !== null &&
      !this.props.isFreeScroll &&
      prevProps.activeIndex !== this.props.activeIndex
    ) {
      this.swiper.slideTo(
        this.props.activeIndex,
        this.props.isFreeScroll ? 350 : 0
      );
    }
  }

  render() {
    return (
      <ScrollArea
        isFreeScroll={this.props.isFreeScroll}
        isSlidesCentered={this.props.isSlidesCentered}
        data-qa-label="top-races-scrollableArea"
        setSwiper={(swiper) => {
          this.setSwiper(swiper);
          if (this.props.setSwipeController) {
            this.props.setSwipeController(swiper);
          }
        }}
        background={this.props.background}
      >
        {this.props.children}
      </ScrollArea>
    );
  }
}
